import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_component = _resolveComponent("profile-component")

  return (_openBlock(), _createBlock(_component_profile_component, {
    user: _ctx.user,
    onLogout: _ctx.onLogout
  }, null, 8, ["user", "onLogout"]))
}